import { EntraUser } from "../../../../services/profileService/model/entraUser/EntraUser";
import { UploadFileInfo } from "@progress/kendo-react-upload";

export interface UARFields {
  jobTitle: string;
  application: string;
  role: string;
}

export interface CPSIFields {
  newUser: EntraUser;
  userToCopy: EntraUser | null;
  locations: string[];
}

export interface TicketFormData {
  module: string;
  title: string;
  description: string;
  reporter: string;
  dueDate: string;
  attachments: UploadFileInfo[];
  ticketTypes: string[];
  UARFields?: {
    selectedUser: EntraUser;
    selectedRole: string;
    locations: string[];
  };
  CPSIFields?: CPSIFields;
}

export interface TicketSummary {
  title: string;
  id: string;
  status: string;
}

export const steps = ['Ticket Types', 'Ticket Details', 'Attachments', 'Confirmation'];